module.exports = __webpack_public_path__ + "img/rizzo.2a366593.svg";